// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"empty_wrapper__2MYPk","onlyTitle":"empty_onlyTitle__3WAAg","title":"empty_title__2rI6f","white":"empty_white__4zNtD","subtitle":"empty_subtitle__1f0sI"};